import React, {useState} from "react";

export const DeleteButton = ({property}) => {
    const [, forceUpdate] = useState();
    const value = property.get();
    if (value == null) {
        return null;
    }
    return (
        <div className="delete button rounded" onClick={() => {
            forceUpdate(property.set(null));
            APP.sceneNode.callDebouncedUpdateSceneOn(property.node);
        }}
             title="löschen">✖</div>
    );
}
